import { makeActionCreator } from '../../utils/actionsUtils';
import { CHANGE_CURRENT_FILTER, RESET_FILTER } from './constants';

export const changeCurrentFilter = makeActionCreator(CHANGE_CURRENT_FILTER, 'id');
export const resetfilter = makeActionCreator(RESET_FILTER);



// WEBPACK FOOTER //
// ./src/services/directory/actions.js